<template>
  <div class="box">
    <myHeader></myHeader>
    <div class="content clearfix">
      <div class="left form">
        <!--        <div class="title">-->
        <!--          乘客資料查詢-->
        <!--        </div>-->
        <div class="tabBox">
          <div class="tabItem active">
            乘客資料查詢
          </div>
          <div class="tabItem" @click="go({name:'declaration_lists'})">
            乘客憑證查詢
          </div>
        </div>
        <div class="item">
          <div class="label">
            請選擇查詢時段
          </div>
          <div class="input">
            <el-date-picker
              value-format="yyyy-MM-dd"
              v-model="rangeDate"
              type="daterange"
              range-separator="至"
              start-placeholder="開始日期"
              end-placeholder="結束日期">
            </el-date-picker>
          </div>
        </div>

        <div class="item">
          <div class="label">
            請選擇查詢的線路
          </div>
          <div class="input">
            <el-select v-model="lineCode" placeholder="請選擇">
              <el-option
                v-for="item in lineLists"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="btnBox">
          <div class="queryBtn" @click="queryClassNo">
            查詢班次號
          </div>
        </div>
        <div class="listsBox">
          <div class="header">
            <span>請選擇班次號</span>
            <div class="allCheckBox" @click="toggleAllChecked">
              <span>全選</span>
              <div class="checked" v-if="isAllChecked">
                <img src="../images/checked.png" alt="checked">
              </div>
              <div class="unCheck" v-if="!isAllChecked"></div>
            </div>
          </div>
          <div class="classLists">
            <div class="row" v-for="c in classNoLists" @click="c.isChecked=!c.isChecked">
              <div class="checked" v-if="c.isChecked">
                <img src="../images/checked.png" alt="checked">
              </div>
              <div class="unCheck" v-if="!c.isChecked"></div>
              <span class="classNo">{{ c.classNo }}</span>
            </div>
          </div>
        </div>
        <div class="btnBox">
          <div class="confirmBtn" @click="queryPassengerLists">
            查詢乘客資料
          </div>
        </div>
      </div>
      <div class="right">
        <div class="body">
          <div class="header">
            <div class="title">
              乘客資料查詢
            </div>
            <div class="exportBtn" @click="exportExcel">
              <img src="../images/exportIcon.png" alt="exportIcon"> 導出
            </div>
          </div>

          <div class="tableBox" ref="tableBox">
            <table>
              <!--正常表頭-->
              <thead ref="tableFixedHead">
              <tr>
                <th style="width: 60px">序號</th>
                <th style="width: 170px">車次ID</th>
                <th style="width: 280px">旅客姓名</th>
                <th style="width: 100px">國家地區</th>
                <th style="width: 100px">性別</th>
                <th style="width: 120px">出生日期</th>
                <th style="width: 130px">證件號碼</th>
                <th style="width: 130px">簽證號碼</th>
                <th style="width: 100px">航空公司</th>
                <th style="width: 100px">航班號</th>
                <th style="width: 140px">航班日期</th>
                <th style="width: 100px">出發國家(地區)</th>
                <th style="width: 100px">中轉國家(地區)</th>
                <th style="width: 100px">到達國家(地區)</th>
                <th style="width: 140px">巴士始發時間</th>
                <th style="width: 130px">車牌號</th>
                <th style="width: 100px">座位號</th>
              </tr>
              </thead>
              <tbody v-if="showPassengerLists.length>0">
              <tr v-for="(u,i) in showPassengerLists">
                <td>{{ (currentPage - 1) * pageSize + i + 1 }}</td>
                <td>{{ u.busId }}</td>
                <td>{{ u.userName }}</td>
                <td>{{ u.nationality }}</td>
                <td>{{ u.gender }}</td>
                <td>{{ u.birthDate }}</td>
                <td>{{ u.documentNo }}</td>
                <td>{{ u.visaNo }}</td>
                <td>{{ u.flightName }}</td>
                <td>{{ u.flightNo }}</td>
                <td>{{ u.flightDepartureDate }}</td>
                <td>{{ u.flightDeparturePlace }}</td>
                <td>{{ u.transitCity }}</td>
                <td>{{ u.finalDestination }}</td>
                <td>{{ u.busDepartureTime }}</td>
                <td>{{ u.LicensePlateNum }}</td>
                <td>{{ u.seatNum }}</td>
              </tr>
              </tbody>
            </table>
          </div>

          <div class="tableBox none" ref="tableBoxExcelTable">
            <table id="excelTable">
              <!--正常表頭-->
              <thead ref="tableFixedHead">
              <tr>
                <th style="width: 60px">序號</th>
                <th style="width: 170px">車次ID</th>
                <th style="width: 280px">旅客姓名</th>
                <th style="width: 100px">國家地區</th>
                <th style="width: 100px">性別</th>
                <th style="width: 120px">出生日期</th>
                <th style="width: 130px">證件號碼</th>
                <th style="width: 130px">簽證號碼</th>
                <th style="width: 100px">航空公司</th>
                <th style="width: 100px">航班號</th>
                <th style="width: 140px">航班日期</th>
                <th style="width: 100px">出發國家(地區)</th>
                <th style="width: 100px">中轉國家(地區)</th>
                <th style="width: 100px">到達國家(地區)</th>
                <th style="width: 140px">巴士始發時間</th>
                <th style="width: 130px">車牌號</th>
                <th style="width: 100px">座位號</th>
              </tr>
              </thead>
              <tbody v-if="passengerLists.length>0">
              <tr v-for="(u,i) in passengerLists">
                <td>{{ i + 1 }}</td>
                <td>{{ u.busId }}</td>
                <td>{{ u.userName }}</td>
                <td>{{ u.nationality }}</td>
                <td>{{ u.gender }}</td>
                <td>{{ u.birthDate }}</td>
                <td>{{ u.documentNo }}</td>
                <td>{{ u.visaNo }}</td>
                <td>{{ u.flightName }}</td>
                <td>{{ u.flightNo }}</td>
                <td>{{ u.flightDepartureDate }}</td>
                <td>{{ u.flightDeparturePlace }}</td>
                <td>{{ u.transitCity }}</td>
                <td>{{ u.finalDestination }}</td>
                <td>{{ u.busDepartureTime }}</td>
                <td>{{ u.LicensePlateNum }}</td>
                <td>{{ u.seatNum }}</td>
              </tr>
              </tbody>
            </table>
          </div>

          <div class="page_box" v-show="passengerLists.length>10">
            <div class="block">
              <el-pagination
                layout="prev, pager, next"
                @current-change="pageChange"
                :page-size="pageSize"
                :current-page="currentPage"
                :total="passengerLists.length">
              </el-pagination>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import myHeader from './commpnents/header.vue'
import XLSX from "xlsx";
import FileSaver from 'file-saver'

export default {
  data()
  {
    return {
      // tabIndex: this.$route.meta.tabIndex,
      rangeDate: null,
      lineCode: "",
      lineLists: [
        {value: "", label: "全部"},
        {value: "HZICLK", label: "珠海口岸->香港機場"},
        {value: "CLKHZI", label: "香港機場->珠海口岸"},
      ],
      //班次號列表
      classNoLists: [],
      //乘客資料列表
      passengerLists: [],
      //當前頁顯示的乘客資料
      showPassengerLists: [],
      //分批的數據
      batchDataInfo: {},
      //當前頁碼
      currentPage: 1,
      //頁面顯示行數
      pageSize: 16,
      //總頁數
      pageCount: 0,
    };
  },
  created()
  {
  },
  computed: {
    isAllChecked()
    {
      if(this.classNoLists.length === 0)
      {
        return false
      }
      return this.classNoLists.every(c => c.isChecked)
    }
  },
  watch: {
    // routeIndex()
    // {
    //   this.tabIndex = this.$route.meta.tabIndex;
    // }
  },
  methods: {
    //查詢班次
    async queryClassNo()
    {
      if(!this.rangeDate)
      {
        this.$notify({title: '警告', message: "請選擇查詢的時段", type: 'warning'});
        return
      }

      let parameter = {
        "begin_date": this.rangeDate[0] + " 00:00:00",
        "end_date": this.rangeDate[1] + " 23:59:59",
        "line_code": this.lineCode
      }
      //清空
      this.classNoLists = []

      this.$dialog.loading.open();
      let res = await this.axios.post(this.IP + this.PATH + '/queryAirPortBusId', parameter)
      this.$dialog.loading.close();
      if(res.data.code === "SUCCESS")
      {

        res.data.responseData.data.map(c => {
          let item = {}
          item.isChecked = false
          item.classNo = c
          //添加到班次號列表
          this.classNoLists.push(item)
        })

      }
      else
      {
        this.$notify({title: '警告', message: res.data.message, type: 'warning'});
      }
    },
    //全選反選
    toggleAllChecked()
    {
      //獲取當前全選狀態
      let status = this.classNoLists[0].isChecked
      //遍歷班次號列表
      this.classNoLists.map(c => {
        c.isChecked = !status
      })
    },
    //查詢乘客資料
    async queryPassengerLists()
    {
      if(!this.rangeDate)
      {
        this.$notify({title: '警告', message: "請選擇查詢的時段", type: 'warning'});
        return
      }

      //班次號
      let bus_id = this.classNoLists.filter(c => c.isChecked).map(_ => _.classNo).join(',')

      let parameter = {
        "begin_date": this.rangeDate[0] + " 00:00:00",
        "end_date": this.rangeDate[1] + " 23:59:59",
        bus_id,
        "line_code": this.lineCode
      }

      //清空
      this.passengerLists = []
      this.batchDataInfo = []
      this.showPassengerLists = []

      this.$dialog.loading.open();
      let res = await this.axios.post(this.IP + this.PATH + '/queryAirportPassengerList', parameter)
      this.$dialog.loading.close();
      if(res.data.code === "SUCCESS")
      {
        //乘客資料列表
        this.passengerLists = res.data.responseData.data

        //沒數據返回
        if(this.passengerLists.length <= 0)
        {
          return
        }

        //總共頁數
        this.pageCount = Math.ceil(this.passengerLists.length / this.pageSize)

        //當前頁號
        let pageNo = 1
        //分批數據
        for(let i = 0; i < this.passengerLists.length; i++)
        {
          if(i > this.pageSize * pageNo - 1)
          {
            pageNo += 1
          }

          if(this.batchDataInfo[pageNo])
          {
            this.batchDataInfo[pageNo].push(this.passengerLists[i])
          }
          else
          {
            this.batchDataInfo[pageNo] = [this.passengerLists[i]]
          }
        }

        //初始化為第壹頁
        this.currentPage = 1
        this.showPassengerLists = this.batchDataInfo[this.currentPage]

        // //測試數據
        // for(let i = 0; i < this.showPassengerLists.length; i++)
        // {
        //   Object.keys(this.showPassengerLists[i]).map(key => {
        //     // this.showPassengerLists[i][key] = "填充測試數據1234567890"
        //     this.showPassengerLists[i][key] = "填充測試數據12345"
        //   })
        // }

        //刷新界面
        this.$forceUpdate()
      }
      else
      {
        this.$notify({title: '警告', message: res.data.message, type: 'warning'});
      }
    },
    //點擊頁碼
    pageChange(pageNo)
    {
      this.currentPage = pageNo
      this.showPassengerLists = this.batchDataInfo[pageNo]
      this.$forceUpdate()
    },
    //導出excel
    exportExcel()
    {
      // 如果沒有數據，不導出
      if(this.passengerLists.length <= 0)
      {
        this.$message({
          message: "沒有數據,不能導出",
          type: "warning",
        })
        return
      }

      this.$nextTick(function()//等待table數據更新渲染
      {
        let fileName = "乘客資料"

        /* generate workbook object from table */
        let wb = XLSX.utils.table_to_book(document.querySelector('#excelTable'), {raw: true})
        /* get binary string as output */
        let wbout = XLSX.write(wb, {bookType: 'xlsx', bookSST: true, type: 'array'})
        try
        {
          FileSaver.saveAs(new Blob([wbout], {type: 'application/octet-stream'}), fileName + '.xlsx')
        } catch(e)
        {
          if(typeof console !== 'undefined')
          {
            console.log(e, wbout)
          }
        }
        return wbout;
      })
    },
    go(params)
    {
      //跳轉路由
      this.$router.push(params)
    },
  },
  components: {
    myHeader,
  }
};
</script>

<style lang="less" scoped>
* {
  margin: 0;
  padding: 0;
  list-style: none;
}

.box {
  /*max-width: 1920rem;*/
  min-width: 1366px;
  /*height: 100%;*/
  /*overflow: auto;*/
  color: #333;
  /*font-family: ".PingFang SC";*/
  background-color: #ffffff;
}

.content {
  width: 100%;
  overflow-x: hidden;
  display: flex;
  justify-content: space-between;
  align-items: center;
  min-height: 500px;
  height: calc(100vh - 0.9rem);
}

.content .left {
  height: 100%;
  width: 22%;
  min-width: 326px;
  //height: 8.57rem; border-right: 1px solid #e8e8e8; box-sizing: border-box;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  flex-direction: column;
  padding: .2rem;
  color: #333333;

  .title {
    font-size: 0.24rem;
  }

  .tabBox {
    display: flex;
    justify-content: space-around;
    align-items: center;
    width: 100%;

    .tabItem {
      cursor: pointer;
      width: 1.5rem;
      height: 0.4rem;
      background-color: #e6e9f1;
      border-radius: 0.05rem;
      display: flex;
      justify-content: center;
      align-items: center;
      color: #333333;

      &.active {
        background-color: #1a50ba;
        color: white;
        cursor: default !important;
      }
    }
  }

  .item {
    margin-top: .2rem;

    .label {
      font-size: 0.14rem;
    }

    .input {
      margin-top: .1rem;

      /deep/ .el-date-editor {
        width: 300px !important;

        .el-range-separator {
          width: 7%;
        }
      }

      /deep/ .el-select-dropdown__item {
        padding: 0 20px !important;
      }

    }
  }

  .btnBox {
    width: 100%;

    .queryBtn, .confirmBtn {
      cursor: pointer;
      margin: .2rem auto;
      color: white;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 2.7rem;
      height: 0.4rem;
      background-color: #1a50ba;
      border-radius: 0.05rem;
    }
  }

  .listsBox {
    width: 100%;

    .header {
      display: flex;
      justify-content: space-between;
      font-size: .14rem;

      .allCheckBox {
        display: flex;
        justify-content: flex-end;
        align-items: center;
        margin-right: .4rem;

        span {
          margin-right: .1rem;
        }

        .checked {
          width: 0.19rem;
          height: 0.19rem;
          box-sizing: border-box;
          background-color: #1a50ba;
          display: flex;
          justify-content: center;
          align-items: center;

          img {
            width: 50%;
            height: 50%;
          }
        }

        .unCheck {
          width: 0.19rem;
          height: 0.19rem;
          border: solid 0.01rem #7c7c7c;
          box-sizing: border-box;
        }
      }
    }

    .classLists {
      margin: .1rem auto 0;
      padding: .2rem;
      background-color: #e6e9f1;
      width: 85%;
      height: 3.8rem;
      overflow-y: auto;

      .row {
        width: 100%;
        padding: .03rem 0;
        cursor: pointer;
        margin-bottom: .15rem;
        display: flex;
        justify-content: flex-start;
        align-items: center;

        &:last-child {
          margin-bottom: 0;
        }

        .checked {
          width: 0.19rem;
          height: 0.19rem;
          box-sizing: border-box;
          background-color: #1a50ba;
          display: flex;
          justify-content: center;
          align-items: center;

          img {
            width: 50%;
            height: 50%;
          }
        }

        .unCheck {
          width: 0.19rem;
          height: 0.19rem;
          border: solid 0.01rem #7c7c7c;
          box-sizing: border-box;
        }

        .classNo {
          margin-left: .2rem;
          font-size: 0.15rem;
          color: #333333;
        }
      }
    }
  }
}

.content .right {
  /*height: 857rem;*/
  background-color: #f5f7f8;
  flex: 1 1 auto;
  min-width: 1000px;
  height: 100%;
  padding: .15rem;

  .body {
    background-color: white;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    flex-direction: column;
    overflow: hidden;
    position: relative;

    .header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: .3rem .3rem;
      height: 0.4rem;
      width: 100%;

      .title {
        font-size: 0.24rem;
      }

      .exportBtn {
        cursor: pointer;
        width: 1rem;
        height: 0.4rem;
        background-color: #30976d;
        border-radius: 0.05rem;
        display: flex;
        justify-content: center;
        align-items: center;
        color: white;

        img {
          width: 0.2rem;
          height: 0.15rem;
          margin-right: 0.1rem;
        }
      }
    }

    .tableBox {
      width: 100%;
      //height: 6rem;
      overflow-x: auto;
      overflow-y: hidden;
      flex: 1 1 auto;
      margin-bottom: .4rem;

      table {
        //width: 100%;
        box-sizing: border-box;
        border-spacing: 0;
        table-layout: fixed;

        thead {
          background-color: #2b5787;
          color: #fff;
          height: .5rem;

          th {
            text-align: center;
          }
        }

        tbody {
          tr {
            &:nth-child(even) {
              background-color: #f5f4f4;
            }

            height: .4rem;

            &:hover {
              background-color: rgb(225, 225, 225) !important;
            }

            td {
              white-space: nowrap; /* 不換行 */
              overflow: hidden; /* 超出部分隱藏 */
              text-overflow: ellipsis; /* 顯示省略號 */

              text-align: center;
              border-bottom: solid 1px #ccc;

              .editBtn {
                cursor: pointer;
                padding: 0 .05rem;
                color: #35bc45;
                //border-bottom: solid 1px #35bc45;
                //padding-bottom: .03rem;
              }

              .delBtn {
                cursor: pointer;
                color: #f0435b;
                padding-right: .05rem;
                text-underline: #f0435b;
                //border-bottom: solid 1px #f0435b;
                //padding-bottom: .03rem;
              }
            }
          }
        }
      }
    }

    .page_box {
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      bottom: 0;
    }
  }


}
</style>



// WEBPACK FOOTER //
// src/views/airport_passenger_lists/index.vue